import React from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import '@/assets/basicModal.scss';

/**
 *基础弹窗
 * @param { visible, content, onCancel, onOk }
 */
const BasicModal = ({ visible, content, onCancel, onOk }) => {
  const { t } = useTranslation(['common']);

  return (
    <Modal
      className='basic-modal'
      visible={visible}
      title={null}
      footer={null}
      onCancel={onCancel}
      centered
    >
      <div className='py-4 pt-3 pb-0'>
        <p className='content fw-bolder' style={{ color: '#001637' }}>
          {content}
        </p>
        <div className='btn-groups d-flex align-items-center justify-content-end'>
          {onCancel ? (
            <Button className='fw-bolder cancel' onClick={onCancel}>
              {t('cancel')}
            </Button>
          ) : null}
          {onOk ? (
            <Button type='primary' className='fw-bolder' onClick={onOk}>
              {t('confirm')}
            </Button>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default BasicModal;
